export default "__VITE_ASSET__zEPOnnjJ__"